module.exports = __webpack_public_path__ + "static/media/vote-nay.7f1277f3.svg";